const IMAGES = {
  SUN: require('./media/sun.svg').default,
  MOON: require('./media/moon.svg').default,
  AUTH_BG: require('./media/auth-bg.svg').default,
  SUN_DARK_MODE: require('./media/sun-dark-mode.svg').default,
  MOON_DARK_MODE: require('./media/moon-dark-mode.svg').default,
  LOCATION: require('./media/location-point.svg').default,
  PHONE: require('./media/phone.svg').default,
  MAIL: require('./media/mail.svg').default,
  FACEBOOK: require('./media/facebook.svg').default,
  ALERT_TRIANGLE: require('./media/alert-triangle.svg').default,
  BACK_ARROW: require('./media/back-arrow.svg').default,

  FLAG_VI: require('./media/vi.png'),
  FLAG_EN: require('./media/en.png'),
  MAIN_LOGO: require('./media/validus-logo.png'),
  GREEN_LOGO: require('./media/green-logo.png'),
  WHITE_LOGO: require('./media/white-logo.png'),
  FOOTER_LEFT: require('./media/footer-left-bg.png'),
  FOOTER_RIGHT: require('./media/footer-right-bg.png'),
  BANNER_BG: require('./media/banner-bg.png'),
  INTRO_1: require('./media/intro-img-1.png'),
  INTRO_2: require('./media/intro-img-2.png'),
  INTRO_3: require('./media/intro-img-3.png'),
  JOURNEY: require('./media/journey.png'),
  THANKS: require('./media/thank-you.png'),

}
export default IMAGES
